import React from 'react';

import './OrganizationList.scss';

export default function OrganizationList(props) {
  const showInputBox = props.view !== 'withoutInputBox';

  return (
    <section id="organizationList">
      {showInputBox && (
        <form id="organizationList_form" onSubmit={(e) => search(e)}>
          <h1 className="organizationList_title">Mijn postcode</h1>
          <input
            required
            autoFocus
            name="code"
            type="number"
            placeholder="Postcode"
            defaultValue={props.code}
          />

          <button tabIndex="0" type="submit">
            Zoeken
          </button>
        </form>
      )}

      {props.list ? (
        props.list.length ? (
          <ul>
            {props.list.slice(0, 10).map((item, idx) => (
              <li key={idx}>
                <a href={buildLink(item, props.link)}>
                  <div className="organizationList_image">
                    <img alt="organization-image" src={item.logoUrl} />
                  </div>

                  <div>
                    <p>{item.displayName}</p>

                    <p className="organizationList_account">
                      (@{item.accountName})
                    </p>

                    <span>{item.distance} kilometer</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <div className="organizationList_no_result_label">
            Er zijn geen organisaties gevonden in dit postcodegebied, probeer
            het opnieuw.
          </div>
        )
      ) : null}
    </section>
  );

  function search(e) {
    e.preventDefault();

    const value = e.target.code.value.trim();

    if (!value) return;

    location.href = `/organizations?code=${value}`;
  }

  function buildLink(item, link) {
    if (link) return link(item.accountName);
    else
      return (
        (item.content[0] || {}).uri || `/channels/${item.primaryChannel.uri}`
      );
  }
}
